import { render, staticRenderFns } from "./customsInfoFileDialog.vue?vue&type=template&id=7df3bc22&scoped=true&"
import script from "./customsInfoFileDialog.vue?vue&type=script&lang=js&"
export * from "./customsInfoFileDialog.vue?vue&type=script&lang=js&"
import style0 from "./customsInfoFileDialog.vue?vue&type=style&index=0&id=7df3bc22&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7df3bc22",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7df3bc22')) {
      api.createRecord('7df3bc22', component.options)
    } else {
      api.reload('7df3bc22', component.options)
    }
    module.hot.accept("./customsInfoFileDialog.vue?vue&type=template&id=7df3bc22&scoped=true&", function () {
      api.rerender('7df3bc22', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Cargo/Job/customsInfoFileDialog.vue"
export default component.exports